<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户ID')" prop="mobile">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('用户ID')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('手机号')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('邮箱')" prop="email">
                <a-input v-model="queryParam.email" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('邮箱')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('性别')" prop="sex">
                <a-select :placeholder="$t('请选择')+$t('性别')" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SexEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-model-item label="状态" prop="status">
                <a-select v-model="queryParam.status" button-style="solid">
                  <a-select-option v-for="(d, index) in dict.type['sys_enable_disable']" :key="index" :value="parseInt(d.value)">
                    {{ d.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="来源" prop="userSource">
                <a-select :placeholder="$t('请选择')+'来源'" style="width: 100%" v-model="queryParam.userSource" allowClear>
                  <a-select-option v-for="(item, index) in customDict.UserSourceEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="注册开始时间" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="注册结束时间" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户状态')" prop="status">
                <a-select :placeholder="$t('请选择')+$t('用户状态')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.TFEnum" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <a-button type="primary" @click="handleSync" v-hasPermi="['biz:user:sync']">
          <a-icon type="sync" />{{ $t('同步im账号') }}
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{ $t('选中导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <auth-company ref="authCompany"/>
      <auth-personal ref="authPersonal"/>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered">
        <span slot="sex" slot-scope="text, record">
          <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
        <span slot="userSource" slot-scope="text, record">
          <a-tooltip>
            <custom-dict-tag :options="customDict.UserSourceEnum" :color="true" :value="record.userSource"/>
            <template slot="title"  v-if="record.userSource ===2 ">
              {{record.inviteUserMobile}}
            </template>
          </a-tooltip>
        </span>
        <!--        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>-->
        <!--        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>-->
        <span slot="status" slot-scope="text, record">
          <a-switch @change="(checked) => onStatusChange(checked,record)" checked-children="正常" un-checked-children="禁用" :checked="record.status===1"/>
        </span>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar" style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.authCompany.handleUpdate(undefined,record.id)" v-if="record.isCompanyAuth">
             <a-icon type="edit" />企业认证信息
          </a>
          <a @click="$refs.authPersonal.handleUpdate(undefined,record.id)" v-if="record.isPersonAuth">
            <a-icon type="edit"/>个人认证信息
          </a>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, delUser,userStatus,syncImUser } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import AuthPersonal from '../authPersonal/modules/CreateForm'
import AuthCompany from '../authCompany/modules/CreateForm'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment';

export default {
  name: 'Appuser',
  components: {
    CreateForm,
    CustomDictTag,
    AuthPersonal,
    AuthCompany
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],

      statusOptions: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        mobile: null,
        email: null,
        nickName: null,
        sex: undefined,
        invitationCode: null,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: '来源',
          dataIndex: 'userSource',
          scopedSlots: { customRender: 'userSource' },
          align: 'center'
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        {
          title: this.$t('用户等级'),
          dataIndex: 'levelName',
          align: 'center'
        },
        {
          title: this.$t('性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          align: 'center'
        },
         {
          title: this.$t('用户状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('注册时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '8%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route: 'getUserRouteList',
  },
  methods: {
    moment,
    getUserRouteList() {
      let params = this.$route.params;
      console.log('用户params',params)
      if (params) {
        for (let key in params) {
          if (this.queryParam.hasOwnProperty(key)) {
            this.queryParam[key] = params[key];
          }
        }
      }
      this.getList();
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id: undefined,
        mobile: undefined,
        email: undefined,
        nickName: undefined,
        sex: undefined,
        invitationCode: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onStatusChange(checked, record) {
      let status = checked ? 1 : 0;
      let data = {id:record.id, status: checked?1:0}
      userStatus(data).then(response => {
        if (response.success) {
          this.$message.success('修改成功', 3);
          this.$emit('ok')
          record.status=status
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleSync () {
      syncImUser({}).then(response => {
        if (response.success) {
          this.$message.success('同步成功', 3);
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/admin/biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      const queryParam = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/biz/user/export', queryParam, `用户信息_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        },
        onCancel () {
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        }
      })
    }
  }
}
</script>
